import { clamp } from "../../../../../lib/html5-software-library/src/ranj/util/MathUtil";

export default class CharacterTracker {
    constructor({ id, startingValue }) {
        this._id = id;
        this._value = startingValue;
    }

    get id() {
        return this._id;
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = clamp(value, CharacterTracker.MIN_VALUE, CharacterTracker.MAX_VALUE);
    }

    toObject() {
        return {
            id: this.id,
            value: this.value
        };
    }

    static fromObject(json) {
        return new CharacterTracker({
            id: json.id,
            startingValue: json.value,
        });
    }

    clone() {
        return new CharacterTracker({
            id: this.id,
            startingValue: this.value,
        });
    }
}

CharacterTracker.MIN_VALUE = 1;
CharacterTracker.MAX_VALUE = 5;